jQuery('.prevent-default a[href="#"]').click(function(){
    return false;
});

jQuery('.prevent-default-bnt').click(function(){
    return false;
});
jQuery(document).ready(function() {
    $('.four-lines .post-excerpt').ellipsis({ lines: 4 });
    //jQuery('.slide-info').ellipsis({ lines: 5 });
}); 

var controls = document.getElementById( "controls" );
var dotsWrapper =document.getElementById("dots-nav-wrapper");
jQuery(document).ready(function($){
	 $('.top-slider').slick({
	 	slidesToShow: 1,
	 	slidesToScroll: 1,
	 	arrows: true,
    autoplay: true,
	 	fade: true,
    dots: true,
    appendDots: dotsWrapper,
	 	appendArrows: controls,
    waitForAnimate: true,
      useTransform: true,
      cssEase: 'cubic-bezier(0.455, 0.030, 0.130, 1.000)',
  }).slickAnimation();
  /*

	 // On before slide change match active thumbnail to current slide
	 $('.top-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
	 	var mySlideNumber = nextSlide;
	});

//UPDATED 
  
	$('.top-slider').on('afterChange', function(event, slick, currentSlide){   
	$('.content').hide().removeClass( "current" );
	$('.content[data-id=' + (currentSlide + 1) + ']').show().addClass( "current" );
	});
  */
});



jQuery(document).ready(function(){
    $('.product-slides').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      autoplay: true,
    });
    $('.tech_videos').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 2, 
      autoplay: true,
    });
   $('a[data-toggle="pill"]').on('shown.bs.tab', function(e) {
       e.target
       e.relatedTarget
       $('.tech_videos').slick('setPosition');
   });
});



jQuery(document).ready(function(){
  $('.customSelect select').each(function(){
      var $this = $(this), numberOfOptions = $(this).children('option').length;
    
      $this.addClass('select-hidden'); 
      $this.wrap('<div class="select"></div>');
      $this.after('<div class="select-styled"></div>');

      var $styledSelect = $this.next('div.select-styled');
      $styledSelect.text($this.children('option').eq(0).text());
    
      var $list = $('<ul />', {
          'class': 'select-options',
          'id': 'propigate-preferred',
      }).insertAfter($styledSelect);
    
      for (var i = 0; i < numberOfOptions; i++) {
          $('<li />', {
              text: $this.children('option').eq(i).text(),
              rel: $this.children('option').eq(i).val(),
              val: i,
          }).appendTo($list);
      }

      var $listItems = $list.children('li');

    
      $styledSelect.click(function(e) {
          e.stopPropagation();
          $('div.select-styled.active').not(this).each(function(){
              $(this).removeClass('active').next('ul.select-options').hide();
          });
          $(this).toggleClass('active').next('ul.select-options').toggle();
      });
    
      $listItems.click(function(e) {
          e.stopPropagation();
          $styledSelect.text($(this).text()).removeClass('active');
          $this.val($(this).attr('rel'));
          $list.hide();
          //console.log($this.val());
      });
    
      $(document).click(function() {
          $styledSelect.removeClass('active');
          $list.hide();
      });

  });
});

$(document).ready(function(){
  $(".dropdown").hover(function(){
    var dropdownMenu = $(this).children(".dropdown-menu");
    if(dropdownMenu.is(":visible")){
      dropdownMenu.parent().toggleClass("open");
    }
  });
});

jQuery(function($) {
    $('#main-nav .dropdown').hover(function() {
    $(this).find('.dropdown-menu').first().stop(true, true).delay(0);
    $(this).addClass( "open" );
    }, function() {
    $(this).find('.dropdown-menu').first().stop(true, true).delay(0);
    $(this).removeClass( "open" );
    });

    $('#main-nav .dropdown > a').click(function(){
        location.href = this.href;
    });
});



$('body').scrollspy({ target: '#navProduct' })


$(document).ready(function(){
  $("#MapsearchInput").on("keyup", function() {
    var value = $(this).val().toLowerCase();
    $("#dist-rep-wrapper .dist-rep").filter(function() {
      $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
    });
  });
});



var MTIProjectId='a3c168f9-498e-4b97-bb5e-d251a2b2819d';
 (function() {
        var mtiTracking = document.createElement('script');
        mtiTracking.type='text/javascript';
        mtiTracking.async='true';
         mtiTracking.src='/wp-content/themes/MagnumV/assets/fonts/LucidaGrande/mtiFontTrackingCode.js';
        (document.getElementsByTagName('head')[0]||document.getElementsByTagName('body')[0]).appendChild( mtiTracking );
   })();

jQuery(function($) {
  $( "#tagFilterByDate li" ).click(function() {
    $('#tagFilterByDate').collapse('hide');
  });
}); 

jQuery(function($) {
  $( "#filterBy li" ).click(function() {
    $('#filterBy').collapse('hide');
  });
}); 

jQuery('.prevent-default a[href="#"]').click(function(){
    return false;
});

jQuery(document).ready(function($) {
  $("[class^='parentterm-']").click(function () {
      var groupNumber = $(this).attr('class').split('-')[1];
      $('.child-panel-'+groupNumber).toggleClass( "display" );
  });
});

//$(document).ready(function(){$("#mobile-nav").stackMenu()});

$('.dropdown-container-slidemorph #mobile-nav').each(function() {
  var self = $(this)

  var label = $('> a .dropmenu-item-label', this) ? $('> a .dropmenu-item-label', this).text() : $('> a', this).text()
  var backlink = $('<li class="dropdown-backlink"><a href="#">' + label + '</a></li>')

  $(this).find('ul').first().prepend(backlink)

  // Attach listeners to the back buttons
  $(this).find('> ul > li').on('click', function(e){
      e.preventDefault()
      e.stopPropagation()

      var self = $(this)
      var container = self.closest('.dropdown-submenu')
      var parentDropdown = container.closest('.dropdown-menu')

      if (!self.hasClass('dropdown-backlink')) {
        container.find('> a .dropmenu-item-content').text(self.text())
      }

      self.closest('.dropdown-container').css({
        'width': parentDropdown.outerWidth(),
        'height': parentDropdown.outerHeight()
      })

      container.removeClass('open')
   })

})
$(function() {
  //toggle class open on button
  $('#mobile-menu').on('hide.bs.collapse', function () {
    $('.navbar-toggler').removeClass('open');
  })
  $('#mobile-menu').on('show.bs.collapse', function () {
    $('.navbar-toggler').addClass('open');
  })
});

jQuery(document).ready(function($) {
  $(".productTermsMenu").click(function () {
      $('.pdrop-wrapper').toggleClass( "show" );
  });
});

$("#video-btm-tabs").click(function() {
    $([document.documentElement, document.body]).animate({
        scrollTop: $("#pills-tab").offset().top
    }, 500);
    $('#pills-videos-tab').trigger('click');
    setTimeout(function() {
    $('#videos-filter .all a').trigger('click');
    }, 500);
});

